import { Box, Grid, Icon, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';

import { TupleFilterInput } from 'app/components/form-controls/tuple-filter-input';
import { Store } from 'app/model';
import { MidFilterUpdate } from 'app/model/mid-filter-update';
import { FilterData } from 'app/model/user-data/filter-data';
import { RootState } from 'app/store';

import { FilterModal } from './filters/filter.modal';
import { addFilterField, clearFilter, removeFilterField, selectMidFilters, updateFilterField } from './tuple.slice';

interface TupleFilterProps {
    onFilter?: () => void;
    onDownload?: () => void;
    store: Store | undefined;

    // redux fields
    filterData: FilterData;

    // redux actions
    addFilterField: () => void;
    removeFilterField: (filter: number) => void;
    updateFilterField: (update: MidFilterUpdate) => void;
    clearFilter: () => void;
}

interface TupleFiltersState {
    filtersOpen: boolean;
}

class TupleFilters extends React.Component<TupleFilterProps, TupleFiltersState> {
    public constructor(props: Readonly<TupleFilterProps> | TupleFilterProps) {
        super(props);

        this.state = {
            filtersOpen: false,
        };
    }

    public render() {
        return (
            <React.Fragment>
                <FilterModal
                    open={this.state.filtersOpen}
                    onClose={() => this.setState({ filtersOpen: false })}
                    store={this.props.store}
                />
                <Box display='flex' flexDirection='row' alignItems='center'>
                    <Box mr={1}>
                        <Typography variant='h6'>Filters</Typography>
                    </Box>
                    <Box>
                        <Tooltip title='Add Filter'>
                            <IconButton onClick={() => this.props.addFilterField()} size='small'>
                                <Icon color='primary'>add</Icon>
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box flexGrow={1} />
                    <Box>
                        <Tooltip title='Clear Filters'>
                            <IconButton size='small' onClick={() => this.props.clearFilter()}>
                                <Icon fontSize='small' color='primary'>
                                    delete_sweep
                                </Icon>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='Manage Filters'>
                            <IconButton
                                size='small'
                                onClick={() => {
                                    this.setState({
                                        filtersOpen: true,
                                    });
                                }}
                            >
                                <Icon fontSize='small' color='primary'>
                                    filter_alt
                                </Icon>
                            </IconButton>
                        </Tooltip>
                        {this.props.onDownload ? (
                            <Tooltip title='Download'>
                                <IconButton size='small' onClick={() => this.props.onDownload?.()}>
                                    <Icon fontSize='small' color='primary'>
                                        download_for_offline
                                    </Icon>
                                </IconButton>
                            </Tooltip>
                        ) : (
                            ''
                        )}
                        <Tooltip title='Apply Filter'>
                            <IconButton onClick={() => this.props.onFilter?.()} size='small'>
                                <Icon color='primary'>published_with_changes</Icon>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Typography className='my-1' variant='body1'>
                    Most filter values are evaluated as RegExes. Exceptions: - MCC can be either regex or comma
                    delimited values; - store and brand ids must be integers (use 0 for all unmapped)
                </Typography>
                <Grid container spacing={1}>
                    {this.props.filterData.filters.map((filter, index) => (
                        <TupleFilterInput
                            key={index}
                            value={filter}
                            onChange={(change) => {
                                this.props.updateFilterField({
                                    field: 'field',
                                    key: index,
                                    value: change.field,
                                });
                                this.props.updateFilterField({
                                    field: 'value',
                                    key: index,
                                    value: change.value,
                                });
                                this.props.updateFilterField({
                                    field: 'negate',
                                    key: index,
                                    value: change.negate,
                                });
                            }}
                            onDelete={() => this.props.removeFilterField(index)}
                        />
                    ))}
                </Grid>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    filterData: selectMidFilters(state),
});

const actions = { addFilterField, removeFilterField, clearFilter, updateFilterField };

const connected = connect(mapStateToProps, actions)(TupleFilters);

export { connected as TupleFilters };
